import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-navIcon8",
  "use": "icon-navIcon8-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-navIcon8\"><path fill-rule=\"evenodd\" d=\"M7.025 5.223a1 1 0 0 0-.78.373L4.293 8.024a1 1 0 0 0 0 1.254l4.929 6.125a1 1 0 0 0 1.558 0l4.929-6.125a1 1 0 0 0 0-1.254l-1.954-2.428a1 1 0 0 0-.779-.373zm.8 3.277a.367.367 0 0 1 .53.011l1.64 1.76 1.65-1.76a.367.367 0 0 1 .531-.01c.15.148.153.393.01.547l-2.193 2.339-2.18-2.34a.395.395 0 0 1 .011-.547\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol